import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const BarChart = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 64 64" {...props}>
    <path
      fill={getColor(color, isColorInherited)}
      d="M20,6H8H6v2v6v2h2h12h2v-2V8V6H20z M20,14H8V8h12V14z"
    />
    <path
      fill={getColor(color, isColorInherited)}
      d="M32,20H8H6v2v6v2h2h24h2v-2v-6v-2H32z M32,28H8v-6h24V28z"
    />
    <path
      fill={getColor(color, isColorInherited)}
      d="M44,34H8H6v2v6v2h2h36h2v-2v-6v-2H44z M44,42H8v-6h36V42z"
    />
    <path
      fill={getColor(color, isColorInherited)}
      d="M56,48H8H6v2v6v2h2h48h2v-2v-6v-2H56z M56,56H8v-6h48V56z"
    />
  </SvgIcon>
);
